








































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ManagementReport extends Vue {
  public rptSalesAnalyse = Components.RptSalesAnalyse;
  public rptSalesSummary = Components.RptSalesSummary;
  public rptPurchaseSummary = Components.RptPurchaseSummary;
  public rptCommodityAnalyse = Components.RptCommodityAnalyse;
  public rptSalesDeliverySchedule = Components.RptSalesDeliverySchedule;
  public rptPurchaseDeliverySchedule = Components.RptPurchaseDeliverySchedule;
  public rptSalesJournal = Components.RptSalesJournal;
  public rptPurchaseJournal = Components.RptPurchaseJournal;
  public rptCommodityJournal = Components.RptCommodityJournal;
  public rptChargeJournal = Components.RptChargeJournal;
  public rptStockBalance = Components.RptStockBalance;
  public rptSupplementCommodity = Components.RptSupplementCommodity;
  public rptReceivePaymentScheduled = Components.RptReceivePaymentScheduled;
  public rptReceivePaymentResult = Components.RptReceivePaymentResult;
  public rptSendPaymentScheduled = Components.RptSendPaymentScheduled;
  public rptSendPaymentResult = Components.RptSendPaymentResult;
  public rptPurchaseCashBalance = Components.RptPurchaseCashBalance;
  public rptSalesCashBalance = Components.RptSalesCashBalance;  
  public rptSlipJournalItem = Components.RptSlipJournalItem;
  public rptTransactionSummary = Components.RptTransactionSummary;

  public showReportDialog(reportClass: any){
    var componentClass = Vue.extend(reportClass);
    var instance = new componentClass();
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
}
